/* drl-pickup.js — applies the block's address-toggle label.

   Almost everything configurable is now rendered server-side by
   snippets/drl-pickup.liquid. The one exception is the per-location address
   toggle: those live inside the list that Dawn's pickup-availability.js fetches
   and injects, so their label has to be written in afterwards.

   Injection is asynchronous and repeats on every variant change, hence the
   observer rather than a one-shot pass. */

(() => {
  const SELECTOR = 'pickup-availability[data-pickup-address-label]';

  function applyLabel(wrapper) {
    const label = wrapper.dataset.pickupAddressLabel;
    if (!label) return;
    wrapper.querySelectorAll('.drl-pickup__more').forEach((summary) => {
      if (summary.textContent !== label) summary.textContent = label;
    });
  }

  function watch(wrapper) {
    if (wrapper.dataset.drlPickupWatched) return;
    wrapper.dataset.drlPickupWatched = 'true';
    applyLabel(wrapper);
    new MutationObserver(() => applyLabel(wrapper)).observe(wrapper, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
